// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__pxHxe","rail":"styles_rail__dpdE+","track":"styles_track__PEkMk","thumb":"styles_thumb__0xx+k","active":"styles_active__e8mV4"};